import React, { Component, Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';

import JsonBlockGenerator from '../components/JsonBlockGenerator';

export default class PropertyInfo extends Component {
  render() {
    return (
      <Fragment>
        <Card>
          <CardBody>
            <JsonBlockGenerator filename={'property_info.json'} />
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}
